module.exports = __webpack_public_path__ + "img/25.1ee43c07.png";